<template>
  <!-- 基本法管理 -->
  <div class="main-container">
    <div class="top-box">
      <div class="top-title">基本法配置</div>
      <Steps :current="curStep">
        <Step title="基本法管理" content="配置适用机构及有效期" @click.native="changeSetp(0)"></Step>
        <Step title="通则" content="配置基本规则或统计口径" @click.native="changeSetp(1)"></Step>
        <Step title="职级及利益组成" content="职级费用项目配置" @click.native="changeSetp(2)"></Step>
        <Step title="考核配置" content="晋升和维持配置" @click.native="changeSetp(3)"></Step>
      </Steps>
    </div>
    <div class="left-box">
      <Input search enter-button v-model="keyword" @on-search="getList($event)" placeholder="搜索基本法名称或适用机构" />
      <div class="list-box">
        <div class="list-item" :class="{ active: bean.id == curBaseId }" v-for="(bean, i) in list" :key="i">
          <span @click="selectBase(bean)">{{ bean.name }}</span>
          <i class="iconfont iconbianji" @click="$refs.editBasicLaw.open(bean)"></i>
        </div>
      </div>
    </div>
    <div class="right-box">
      <!-- 基本法管理 -->
      <setp-mechanism v-show="curStep == 0" ref="setpMechanism" @next="changeSetp(1)" ></setp-mechanism>
      <!-- 通则 -->
      <setp-rule v-show="curStep == 1" ref="setpRule" @next="changeSetp(2)" @prev="changeSetp(0)"></setp-rule>
      <!-- 职级及利益组成 -->
      <setp-rank v-show="curStep == 2" ref="setpRank" @next="changeSetp(3)" @prev="changeSetp(1)"></setp-rank>
      <!-- 考核配置 -->
      <setp-config v-show="curStep == 3" ref="setpConfig" @prev="changeSetp(2)"></setp-config>
    </div>
    <!-- 编辑基本法 -->
    <edit-basic-law ref="editBasicLaw" @reload="getList()"></edit-basic-law>
  </div>
</template>
<script>
import selectTree from '@/components/system/selectTree3';
import editBasicLaw from './components/editBasicLaw';
import setpMechanism from './components/setpMechanism';
import setpRule from './components/setpRule';
import setpRank from './components/setpRank';
import setpConfig from './components/setpConfig';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: { selectTree, setpMechanism, setpRule, setpRank, setpConfig, editBasicLaw },
  data() {
    return {
      curStep: 0,
      keyword: '',
      curBaseId: '', //当前基本法
      list: []
    };
  },
  computed: {
    curBase() {
      if (this.list.length > 0 && this.curBaseId) {
        return this.list.find(item => item.id == this.curBaseId);
      } else {
        return {};
      }
    }
  },
  activated() {
    this.getList();
  },
  methods: {
    // 改变步骤
    async changeSetp(i) {
      await this.getList();
      this.curStep = i;
      const setpArr = ['setpMechanism', 'setpRule', 'setpRank', 'setpConfig'];
      this.$refs[setpArr[i]].init(this.curBase);
    },
    // 选择基本法
    selectBase(bean){
      this.curBaseId = bean.id;
      this.$nextTick(()=>{
        this.changeSetp(0);
      })
    },
    // 获取基本法列表
    getList() {
      return this.$http({
        url: '/buz/baseMethod/list',
        type: 'post',
        data: {
          name: this.keyword,
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.list = res.data;
        if ((!this.curBaseId || !this.curBase.id) && res.data[0]) {
          this.selectBase(res.data[0])
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
